import React, { CSSProperties, ReactNode } from 'react';

import * as S from './styled';
import IDHelpers from '../../../core/helpers/IDHelper';

interface IProps {
  children?: ReactNode[];
  style?: CSSProperties;
}

const ReusableDivider = ({ children, style }: IProps) => (
  <S.Wrapper style={{ ...style }}>
    {children &&
      children.map((el) => <div key={IDHelpers.generateID()}>{el}</div>)}
  </S.Wrapper>
);

export default ReusableDivider;
